<template>

    <div class="box">
        <div class="box-offset">
            <div class="box-ttl-wrap">
                <div class="box-ttl">Site Bans</div>
                <button class="btn btn--outline-primary btn--middle"
                        @click="showCustomModal('employee', 1)">+ Add New</button>
                <AddNewItemModal
                    title="Add New Employee"
                    confirm-text="Save"
                    :id="getCustomModalId('employee', 1)"
                    reject-text="Cancel"
                    :type="`applicant`"
                    @confirm="banApplicant"
                ></AddNewItemModal>

            </div>
            <div class="table-holder table-responsive">
                <table class="table table-uniform">
                    <thead>
                    <tr>
                        <th>Employee Name</th>
                        <th>Banned by</th>
                        <th>Date</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="employee in bannedEmployees"
                    :key="employee.banned_employer_id">
                        <td>
                            <p><b>
                                {{ employee.banned_employer.name }} {{ employee.banned_employer.last_name}}
                            </b>
                            </p>
                        </td>
                        <td>
                            <p>
                                {{ employee.banned_by.name}} {{ employee.banned_by.last_name}}
                            </p>
                        </td>
                        <td>
                            <div class="text-14 color--text-gray">
                                {{calculateDate(employee.created_at) }}
                            </div>
                        </td>
                        <td class="text-right">
                            <div class="action-block">
                                <button
                                    class="img-btn delete-link"
                                    @click="showDeleteModal(employee.id, 'employee')"
                                ><img src="/img/svg/on.svg" alt=""></button>
                                <ActionModal confirm-text="Yes"
                                             reject-text="No"
                                             :modalId="getDeleteModalId(employee.id, 'employee')"
                                             @confirm="deleteEmployee(employee.id)">
                                    <template #body>
                                        <div class="text-center mb-4">
                                            <h4>
                                                Are you sure you want <br> to delete this item?
                                            </h4>
                                        </div>
                                    </template>
                                </ActionModal>
                            </div>
                        </td>
                    </tr>

                    </tbody>
                </table>
            </div>
            <div class="d-flex justify-content-between">
            </div>
        </div>
    </div>

</template>

<script>
 import AddNewItemModal from "../../../../../../resources/js/components/AddNewItemModal.vue";
 import SiteClientsService from "../services/SiteClientsService";
 import CommonService from "../../../../AppUser/resources/js/services/CommonService";
 import ActionModal from "../../../../../../resources/js/components/ActionModal.vue";
 import DateConverter from "../../../../../../resources/js/mixins/DateConverter";
 import ModalHandler from "../../../../../../resources/js/mixins/ModalHandler";

 export default {
     name: "BannedEmployers",
     components: {ActionModal, AddNewItemModal},
     props: {
         clientInfo: {
             type: Object,
             required: true,
         }
     },
     mixins: [DateConverter, ModalHandler],
     data() {
         return {
             bannedEmployees: this.clientInfo.banned_employers ?? []
         }
     },
     methods: {
         async banApplicant(item) {
             if (item) {
                 this.$showLoadingMessage()
                 const found = this.bannedEmployees.find(el => el.banned_employer_id === item)
                 if (!found) {
                     try {
                         const {data: result } = await SiteClientsService.addToBannedList(this.clientInfo.id, item);
                         this.bannedEmployees = result
                         $('#employee-modal').modal('hide');
                         this.$showSuccessMessage('The employee was banned');
                     } catch (error) {
                         this.$showErrorMessage('The employee was not banned. Please try again');
                     }
                 } else {
                     $('#employee-modal').modal('hide');
                     this.$showInfoSwal();
                 }
             } else {
                 this.$showErrorMessage('Please select the employee');
             }

         },
         async deleteEmployee(id) {
             this.$showLoadingMessage();
             try {
                 this.bannedEmployees = this.bannedEmployees.filter(empl => empl.id !== id)
                 this.$showSuccessMessageDelete();
                 await SiteClientsService.deleteEmployee(id)
             } catch (error) {
                 this.$showErrorMessage('The banned employee was not removed. Please try again');
             }
         },
     },
 }

</script>

<style scoped>

</style>
